export const CELETUS_CONTACT_SUPPORT =
  'https://wa.me/556281615682?text=Oi,%20preciso%20de%20ajuda%20com%20a%20Celetus,%20meu%20nome%20%C3%A9:%20'
